import React from 'react';
import { useSEO } from '@/hooks/useSEO';
import { PageHero } from '@/pages/About';
import { useLanguage } from '@/contexts/LanguageContext';

const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1633354322759-d4cd35fa8a0b?w=2000&q=80&auto=format&fit=crop',
  commercial: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=2000&q=80&auto=format&fit=crop',
  residential: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=2000&q=80&auto=format&fit=crop',
  development: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=2000&q=80&auto=format&fit=crop',
};

const Investments = () => {
  const { t } = useLanguage();
  useSEO({ title: 'Investicijos — UAB MAIŠIAGALA GROUP', description: 'Investavimo strategija ir kryptys: komercinis ir gyvenamasis nekilnojamasis turtas, plėtros projektai.', path: '/investments' });
  const cats = ['commercial', 'residential', 'development'];

  return (
    <div data-testid="investments-page">
      <PageHero title={t('investments.title')} image={IMAGES.hero} />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <h2 className="font-serif text-white text-3xl sm:text-4xl tracking-tight">{t('investments.strategy_title')}</h2>
          </div>
          <p className="md:col-span-7 text-white/70 text-lg leading-relaxed">{t('investments.strategy_body')}</p>
        </div>

        <p className="text-white/60 max-w-2xl text-lg mb-12">{t('investments.lead')}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#262626]">
          {cats.map((c, i) => (
            <div key={c} className="bg-[#0A0A0A] group relative overflow-hidden" data-testid={`invest-cat-${c}`}>
              <div
                className="absolute inset-0 bg-cover bg-center opacity-30 group-hover:opacity-50 group-hover:scale-105 transition-all duration-700"
                style={{ backgroundImage: `url(${IMAGES[c]})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#0A0A0A]/90 to-[#0A0A0A]/40" />
              <div className="relative p-10 md:p-14 min-h-[320px] flex flex-col justify-end">
                <div className="text-gold font-serif text-3xl mb-6">0{i + 1}</div>
                <h3 className="font-serif text-white text-2xl sm:text-3xl tracking-tight mb-3">
                  {t(`investments.categories.${c}.t`)}
                </h3>
                <p className="text-white/70 leading-relaxed max-w-md">{t(`investments.categories.${c}.d`)}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Investments;
